import axios from 'axios';

// Create axios instance with base configuration
const api = axios.create({
  // Base URL is /app since our API calls already include /api/
  baseURL: '/app',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only redirect on 401 if it's NOT the login or signup endpoint
    // (login/signup are expected to return 401 for invalid credentials)
    const isAuthEndpoint = error.config?.url?.includes('/api/login') ||
                          error.config?.url?.includes('/api/signup');

    if (error.response?.status === 401 && !isAuthEndpoint) {
      // Token expired or invalid - redirect to login
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      window.location.href = '/app/auth';
    }
    return Promise.reject(error);
  }
);

export default api;

// Helper function to construct full URLs for assets
export const getAssetUrl = (path) => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  
  return `/app/${cleanPath}`;
};

// Helper function for API image URLs
export const getApiImageUrl = (path) => {
  // For API paths, prepend /app in all environments
  if (path.startsWith('/api/')) {
    return `/app${path}`;
  }
  return path;
};